import React from 'react';

const COLORS = [
  // Blues & Cyans
  { name: "Skyglint", gradient: "linear-gradient(135deg, #0056b3 0%, #003d82 100%)" },
  { name: "Seraphim Blue", gradient: "linear-gradient(135deg, #0080cc 0%, #2b5ce6 100%)" },
  { name: "Frostwink", gradient: "linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)" },
  { name: "Oceancloud", gradient: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)" },
  { name: "Deep Sea", gradient: "linear-gradient(135deg, #1a237e 0%, #283593 100%)" },

  // Purples & Violets
  { name: "Dreamburst", gradient: "linear-gradient(135deg, #4527a0 0%, #512da8 100%)" },
  { name: "Nightfire", gradient: "linear-gradient(135deg, #4a148c 0%, #6a1b9a 100%)" },
  { name: "Electric Haze", gradient: "linear-gradient(135deg, #ad1457 0%, #4a148c 100%)" },
  { name: "Lavashock", gradient: "linear-gradient(135deg, #8e24aa 0%, #5e35b1 100%)" },
  { name: "Mystdust", gradient: "linear-gradient(135deg, #7b1fa2 0%, #3f51b5 100%)" },

  // Pinks & Corals
  { name: "Coralite", gradient: "linear-gradient(135deg, #c2185b 0%, #e91e63 100%)" },
  { name: "Cherrywave", gradient: "linear-gradient(135deg, #d84315 0%, #c2185b 100%)" },
  { name: "Crimson Sky", gradient: "linear-gradient(135deg, #d32f2f 0%, #f57c00 100%)" },
  { name: "Rosegold", gradient: "linear-gradient(135deg, #ad1457 0%, #e53935 100%)" },
  { name: "Blushfire", gradient: "linear-gradient(135deg, #c2185b 0%, #e91e63 100%)" },

  // Oranges & Yellows
  { name: "Sunblush", gradient: "linear-gradient(135deg, #ef6c00 0%, #d84315 100%)" },
  { name: "Peachfuzz", gradient: "linear-gradient(135deg, #ff8f00 0%, #f57c00 100%)" },
  { name: "Amberfade", gradient: "linear-gradient(135deg, #ff8f00 0%, #e65100 100%)" },
  { name: "Goldflare", gradient: "linear-gradient(135deg, #ff6f00 0%, #ff8f00 100%)" },
  { name: "Honeywave", gradient: "linear-gradient(135deg, #e65100 0%, #ff6f00 100%)" },

  // Greens & Teals
  { name: "Lushbeam", gradient: "linear-gradient(135deg, #2e7d32 0%, #00695c 100%)" },
  { name: "Mossglow", gradient: "linear-gradient(135deg, #388e3c 0%, #1976d2 100%)" },
  { name: "Meadowmint", gradient: "linear-gradient(135deg, #00695c 0%, #4527a0 100%)" },
  { name: "Forestmist", gradient: "linear-gradient(135deg, #1b5e20 0%, #00695c 100%)" },
  { name: "Stormbliss", gradient: "linear-gradient(135deg, #424242 0%, #212121 100%)" }
];

function ColorPickerWidget({ x = 0, y = 0, onColorSelect, colors = null, style = {} }) {

  // The active map theme may supply its own palette (e.g. chalk pastels).
  const paletteColors = Array.isArray(colors) && colors.length > 0 ? colors : COLORS;
  const numAcross = 5
  //const height = Math.ceil(COLORS.length / numAcross) * 24;

  const handleColorClick = (color) => {
    if (onColorSelect) {
      onColorSelect(color);
    }
  };


  const containerStyle = {
    position: 'absolute',
    left: x,
    top: y,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e5e7eb',
    padding: '8px',
    zIndex: 50,
    ...style
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${numAcross}, 1fr)`,
    gap: '4px',
    width: '128px'
  };



  const colorSquareStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    cursor: 'pointer',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '1px solid #f3f4f6'
  };

  return (
    <div style={containerStyle}>
      <div style={gridStyle}>
        {paletteColors.map((color, index) => (
          <div
            key={index}
            style={{
              ...colorSquareStyle,
              background: color.gradient
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Clicked color:', color.name); // Debug log
              handleColorClick(color);
            }}
            title={color.name}
          />
        ))}
      </div>
    </div>
  );
}



export { ColorPickerWidget, COLORS };